import React from "react";
import styles from "./style.module.css";
import { Images } from "assets";
import useNav from "hooks/useNav";
import ScreenId from "utils/ScreenId";
import useUser from "hooks/useUser";

export function B2bLandingPage(params: {
  [key: string]: string | number | undefined;
}) {
  const { user } = useUser();
  const { navigate } = useNav();

  return (
    <div className={styles.wrap}>
      <img src={Images.promotionB2b} />
      <button
        className={styles.btn}
        style={{
          width: "76%",
          aspectRatio: 410 / 76,
          bottom: "10.48%",
          left: "12%",
        }}
        onClick={() => {
          if (user) {
            navigate({ url: ScreenId.PROMOTION_B2B });
          } else {
            navigate({
              url: ScreenId.SIGN_IN,
              state: { prevParam: params, prevPage: ScreenId.PROMOTION },
            });
          }
        }}
      >
        인증하고 포인트 받기
      </button>
    </div>
  );
}
